import JobSeriesCard from "@molecules/ObjectCard/ObjectCards/JobSeriesCard/JobSeriesCard"

import CardsView from "@organisms/ObjectsView/CardsView/CardsView"

export default function JobSeriesCardsView() {
    return (
        <CardsView.List<JobSeries>>
            {(series, displayedAttributes, cardProps) => (
                <JobSeriesCard series={series} displayedAttributes={displayedAttributes} {...cardProps} />
            )}
        </CardsView.List>
    )
}
